import { render, staticRenderFns } from "./BlockRegisterFilesAndTerms.vue?vue&type=template&id=49c42b20&"
import script from "./BlockRegisterFilesAndTerms.vue?vue&type=script&lang=js&"
export * from "./BlockRegisterFilesAndTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports